import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('enable_classification_org_default');
	},
};
